



































































































import Vue from 'vue'
import FullModalLayout from '@/components/modal/basics/FullModal/FullModalLayout.vue'
import FullModalHeaderCloseButton from '@/components/modal/basics/FullModal/FullModalHeader/FullModalHeaderCloseButton.vue'
import FullModalHeaderTitle from '@/components/modal/basics/FullModal/FullModalHeader/FullModalHeaderTitle.vue'
import Avatar from '@/components/globals/Avatar.vue'
import Button from '@/components/globals/Button.vue'
import InputWithValidation from '@/components/globals/basics/InputWithValidation.vue'
import Loading from '@/components/globals/basics/Loading/Loading.vue'
import { Gender } from '@/core/Programs'

export default Vue.extend({
  components: {
    FullModalLayout,
    FullModalHeaderCloseButton,
    FullModalHeaderTitle,
    Avatar,
    Button,
    InputWithValidation,
    Loading,
  },
  props: {
    values: {
      type: Object as () => {
        nickname: string
        imagePath: string
        enthusiasmComment: string
      },
      required: true,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      nickname: '',
      enthusiasmComment: '',
      imagePath: '',
      imageSrc: null as string | null,
      imageFile: null as File | null,
    }
  },
  computed: {
    user(): { name: string } {
      return this.$store.getters['auth/user']
    },
    gender(): Gender {
      return this.$store.getters['auth/sex']
    },
    isValid(): boolean {
      return (
        this.nickname !== '' &&
        this.nickname.length >= 2 &&
        this.nickname.length <= 20
      )
    },
  },
  watch: {
    values() {
      this.updateValues()
    },
  },
  methods: {
    onModalOpen() {
      this.updateValues()
    },
    updateValues() {
      this.nickname = this.values.nickname
      this.enthusiasmComment = this.values.enthusiasmComment
      this.imagePath = this.values.imagePath
      this.imageFile = null
    },
    onImageUploaded(e: Event) {
      if (!(e.target instanceof HTMLInputElement)) return
      if (!e.target.files) return

      this.imageFile = e.target.files[0]
      this.createImage(this.imageFile)
    },
    onImageUpload() {
      ;(this.$refs.avatarImageInput as any).click()
    },
    createImage(image: File) {
      const reader = new FileReader()
      reader.readAsDataURL(image)
      reader.onload = () => {
        this.imageSrc = reader.result as string
      }
    },
    onSubmit() {
      this.$emit('submit', {
        nickname: this.nickname,
        imageFile: this.imageFile,
        enthusiasmComment: this.enthusiasmComment,
      })
      this.$modal.pop()
    },
    onClose() {
      this.$modal.pop()
      this.$emit('onClose')
    },
  },
})
